import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import { Button, SplitButton, MenuItem } from 'react-bootstrap'
import { Translate, Actions, utils, components, consts } from 'unity-core'
const { getEnv, userUtils } = utils
//import AppSelectToggle from './AppSelectToggle'
import AvailableUpdates from './AvailableUpdates'
const { Timer, LanguagePicker } = components
import { push } from 'react-router-redux'
const { Routes } = consts

const propTypes = {
  user: PropTypes.object,
  strings: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  changeRoute: PropTypes.func.isRequired
}
const defaultProps = {
  user: {
    isAuthenticated: false,
    expiry: moment(),
    email: '',
    userName: '',
    displayName: ''
  }
}

class Header extends React.Component {
  constructor(props) {
    super(props)
  }

  onLogOut = (e) => {
    e.preventDefault()
    this.props.logout()
  }

  render() {
    const { strings, user, changeRoute } = this.props
    return (
      <nav id="globalNav" className="dnb-global-header header-utility-btns navbar navbar-default">
        <div className="container-fluid">
          {/*userUtils.IsAuthorized(user) && <AppSelectToggle {...user} />*/}
          <div className="navbar-header">
          <a href={`#/${Routes.HOME}`}>
            <div className="navbar-brand">
              <span className="slide-left-10">{strings.title}</span>
              <span className="sr-only"><span dangerouslySetInnerHTML={{ __html: strings.reader }} /></span>
            </div>
            </a>
          </div>
          <div className="slide-right-30 slide-top-10">
            <AvailableUpdates />
            <div className="pull-right ">
              <div className="pull-left slide-top-10" style={{ 'paddingRight': '20px', 'minWidth': '50px' }}>
                <Button bsStyle="default" href={getEnv().UWikiUrl} target="_blank">{strings.wiki}</Button>
              </div>
              <div className="pull-left slide-top-10" style={{ 'paddingRight': '20px', 'minWidth': '150px' }}><LanguagePicker /></div>
              {userUtils.IsAuthenticated(user) ?
                <div className="pull-left slide-top-10" style={{ 'paddingRight': '15px' }}>
                  <SplitButton bsStyle="default" title={user.displayName} id="split-button-basic">
                    <MenuItem eventKey="1"><Button bsStyle="primary" onClick={() => changeRoute('/Settings')}>{strings.settings}</Button></MenuItem>
                    <MenuItem eventKey="2"><Button bsStyle="primary" onClick={this.onLogOut}>{strings.logout}</Button></MenuItem>
                  </SplitButton>
                </div> : <div hidden />
              }
              <div className="pull-right slide-top-15"><Timer /></div>
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

Header.propTypes = propTypes
Header.defaultProps = defaultProps

const mapStateToProps = (state) => {
  return {
    user: state.user
  }
}
const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(Actions.User.logout()),
  changeRoute: route => dispatch(push(route))
})

const decorators = _.flow([
  connect(mapStateToProps, mapDispatchToProps),
  Translate('Header')
]);

export default decorators(Header)

/*
<nav id="globalNav" className="dnb-global-header header-utility-btns navbar navbar-default hidden">
  <div className="container-fluid">
    <div className="navbar-header">
      <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#example-navbar-collapse-1">
        <span className="sr-only">Toggle navigation</span>
        <span className="icon-bar" />
        <span className="icon-bar" />
        <span className="icon-bar" />
      </button>

      <button className="navbar-toggle collapsed mobile-search-toggle" data-toggle="collapse" data-target="#example-search-collapse-1"><i className="icon icon-search" /></button>

      <a className="navbar-brand" href="#"><span className="sr-only">D&amp;B Product Design Guide Demo</span></a>

      <div id="example-search-collapse-1" className="search-group collapse navbar-collapse">
        <form className="navbar-form navbar-left " role="search" style={{width: '238px'}}>
          <div className="input-group">
            <div className="search-selector input-group-btn">
              <button type="button" className="btn btn-navbar-search-dropdown dropdown-toggle hidden-xs" data-toggle="dropdown" aria-expanded="false">Company <span className="caret" /></button>
              <ul className="dropdown-menu" role="menu">
                <li className="active"><a href="#">Company</a></li>
                <li><a href="#">Option</a></li>
                <li><a href="#">Another</a></li>
                <li><a href="#">Really Long Name</a></li>
                <li><a href="#">Short</a></li>
                <li><a href="#">One More</a></li>
              </ul>
              <span className="mobile-search-active-indicator" />
            </div>

            <input type="text" className="form-control search" placeholder="Search (demo only)..." data-no-focus-placeholder="Search (demo only)..."
                  data-focus-placeholder="Place a descriptive message here (demo search doesn't actually search)" />

            <span className="input-group-btn">
              <button type="submit" className="btn btn-default btn-search"><i className="icon icon-search hidden-xs" /><span className="sr-only">Submit</span></button>
            </span>

          </div>
        </form>
      </div>
    </div>


    <div className="collapse navbar-collapse" id="example-navbar-collapse-1">
      <ul className="nav navbar-nav navbar-right">
        <li className="active">
          <a href="#">Home <span className="sr-only">(current)</span></a>
        </li>
        <li>
          <a href="#">Details</a>
        </li>
        <li className="utility-btn utility-btn-first">
          <a href="#" className="alerts"><i className="icon icon-alert alert-badge hidden-xs"></i><span className="visible-xs-inline">Alerts</span></a>
        </li>
        <li className="dropdown utility-btn">
          <a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false"><i className="icon icon-user hidden-xs"></i>
          <span className="visible-xs-inline">Profile</span><span className="caret"></span></a>
          <ul className="dropdown-menu" role="menu">
            <li><a href="#">Action</a></li>
            <li><a href="#">Another action</a></li>
            <li><a href="#">Something else here</a></li>
            <li><a href="#">Action</a></li>
            <li><a href="#">Another action</a></li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>*/
